'use strict';
import { connect } from 'react-redux';
import 
{
	programSelector,
	resourceStatusSelector
} from '../../selectors';

var React = require('react');
var PageLoader = require('../PageLoader');
var Program = require('../Program');
var LoadAction = require('../../actions').loadProgrampage;
var executeLoadActions = require('../../addons/executeLoadActions');

class ProgramHandler extends React.Component {
	render() {
		if(this.props.status === 'RESOURCE_STATUS_FETCHING') {
			return (
				<PageLoader key={`loading-${this.props.params.program}`}/>
			);
		}
		return (<Program model={this.props.program} key={`program-${this.props.params.program}`}/>);
	}
}

ProgramHandler.handlerActions = [LoadAction];
ProgramHandler.contextTypes = {
	store: React.PropTypes.object.isRequired
};

function select(state, props) {
	return {
		status: resourceStatusSelector(state, { type:'programs', id:props.params.program }),
		program: programSelector(state, { type:'programs', id:props.params.program })
	};
}
export default connect(select)(executeLoadActions(ProgramHandler));




/** WEBPACK FOOTER **
 ** ./app/components/ProgramHandler/index.js
 **/